import 'whatwg-fetch';
import config from '../../config/config';

const {
    API_CATEGORIES_URL
} = config;

const consumerKey = process.env.REACT_APP_API_CONSUMER_KEY;
const consumerSecret = process.env.REACT_APP_API_CONSUMER_SECRET;

const apiUrl = process.env.REACT_APP_API_URL;

export const categoriesApi = {
    fetchSubcategories: async (parentId) => {
        const response = await fetch(
            `${apiUrl}/wp-json/app/v1/subcategories?parent_id=${parentId}`,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const result = await response.json();
        return result.data || [];
    },

    fetchList: async (params = {}) => {
        const queryParams = new URLSearchParams({
            consumer_key: consumerKey,
            consumer_secret: consumerSecret,
            ...params,
        }).toString();

        const fetchOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        };

        const response = await fetch(
            `${API_CATEGORIES_URL}?${queryParams}`,
            fetchOptions
        );

        if(!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();

        return {
            data: Array.isArray(data) ? data : [],
        }
    }
}